export const getLocalState = state => state.additionalFilters
export const getResearchSections = state => state.sections
export const getFields = state => state.additionalFilters.fields
export const getSectionSelected = state => state.additionalFilters.sectionSelected